/* ============================================================================
   LAH — MODO DE TESTE DOS AVISOS
   Tema: Testes de implementacao (0.8)

   Com ?lahdebug na URL, apaga as marcas que limitam os avisos a um por dia e
   a uma vez por visita. Sem o parametro, este arquivo nao faz absolutamente
   nada — sai na primeira linha.

   ============================================================================
   POR QUE UM ARQUIVO A PARTE
   ============================================================================
   Poderia estar dentro de cada aviso, mas isso espalharia logica de teste pelo
   codigo que roda para o cliente. Aqui fica num lugar so, obvio de achar e
   obvio de remover.

   E ele roda ANTES dos avisos (ordem de carregamento no snippet global), entao
   quando eles consultam as marcas, elas ja nao existem.

   ============================================================================
   O QUE CADA MARCA CONTROLA
   ============================================================================
     lah_retomar_toast_dia ... a cota diaria, compartilhada pelos dois avisos
     lah_carrinho_sessao .... a marca de "ja estive aqui nesta visita", que
                              impede o aviso de carrinho de aparecer para quem
                              acabou de adicionar

   As configuracoes guardadas (lah_config_<id>) NAO sao apagadas: elas sao o
   conteudo do teste, nao o que o limita. Para zerar tambem essas, use
   ?lahdebug=tudo.
   ============================================================================ */

(function () {
    'use strict';

    var busca = window.location.search;
    if (busca.indexOf('lahdebug') === -1) return;

    var tudo = busca.indexOf('lahdebug=tudo') !== -1;

    try {
        window.localStorage.removeItem('lah_retomar_toast_dia');
        window.sessionStorage.removeItem('lah_carrinho_sessao');

        if (tudo) {
            var apagar = [];

            for (var i = 0; i < window.localStorage.length; i++) {
                var k = window.localStorage.key(i);
                if (k && k.indexOf('lah_config_') === 0) apagar.push(k);
            }

            /* Recolhemos as chaves antes de apagar: remover durante a
               varredura desloca os indices e pula itens. */
            apagar.forEach(function (k) {
                window.localStorage.removeItem(k);
            });
        }

        console.log('[lah-debug] marcas de exibicao apagadas' +
            (tudo ? ' + configuracoes guardadas' : '') +
            ' — os avisos podem aparecer de novo');
    } catch (e) {
        console.log('[lah-debug] armazenamento indisponivel');
    }
})();
